'use client';

import { useWindowSize } from 'usehooks-ts';

const MOBILE_MAX_WIDTH = 1024;
const MOBILE_CLASS_NAME = 'mobile';

let currentWidth = 0;

export function isMobileSize() {
    return currentWidth <= MOBILE_MAX_WIDTH;
}

function updateMobileClass() {
    // This will be rendered on server side as well as client side.
    if (typeof document === 'undefined') return;

    if (isMobileSize()) {
        document.body.classList.add(MOBILE_CLASS_NAME);
    } else {
        document.body.classList.remove(MOBILE_CLASS_NAME);
    }
}

// Hook for supporting responsive UI.
export function useResponsiveUi() {
    const { width } = useWindowSize();
    currentWidth = width;

    updateMobileClass();

    return { isMobile: isMobileSize() };
}
